import { Box } from "@mui/material";
import { Link } from "@tanstack/react-router";
import { memo } from "react";

import type { AuthOutlineButtonProps } from "./AuthOutlineButton.types";
import * as styles from "./AuthOutlineButton.styles";

export type { AuthOutlineButtonProps } from "./AuthOutlineButton.types";

export const AuthOutlineButton = memo(function AuthOutlineButton({
  children,
  icon,
  onClick,
  to,
}: AuthOutlineButtonProps) {
  const content = (
    <>
      <Box sx={styles.iconWrap}>{icon}</Box>
      {children}
    </>
  );

  if (to) {
    return (
      <Box component={Link} to={to} sx={styles.root}>
        {content}
      </Box>
    );
  }

  return (
    <Box component="button" type="button" sx={styles.root} onClick={onClick}>
      {content}
    </Box>
  );
});
